import { useCallback } from 'react';
import { CTA_ON_CLICK_FUNCTION_IDS } from "./constants";
import { ButtonContent } from "./ButtonContent";
import API_service from "xAppLib/providers/API_service";

/*
	Avoid using app.trigger in future as the plan is to have this server side generated,
	and app.trigger is not supported in that context. Pass functions as props instead. 
	Cumbersome I know but is necessary.
*/
const OnClickButton = ({ onClickFunctionId, buttonContentProps, parsedFunctions = {}, downloadableAssetId }) => {
	const onClick = useCallback(async () => {
		let downloadResponse
		switch (onClickFunctionId) {
			case CTA_ON_CLICK_FUNCTION_IDS.OPEN_CONDITIONS_MENU:
				app.trigger(app.events.SIDEMENU, { view: "Conditions" });
				break;
			case CTA_ON_CLICK_FUNCTION_IDS.OPEN_SERVICE_MENU:
				app.trigger(app.events.SIDEMENU, { view: "Services" });
				break;
			case CTA_ON_CLICK_FUNCTION_IDS.OPEN_YOUFOODZ_TOS:
				parsedFunctions[CTA_ON_CLICK_FUNCTION_IDS.OPEN_YOUFOODZ_TOS]?.();
				break;
			case CTA_ON_CLICK_FUNCTION_IDS.OPEN_WL_TOS:
				parsedFunctions[CTA_ON_CLICK_FUNCTION_IDS.OPEN_WL_TOS]?.();
				break;
			case CTA_ON_CLICK_FUNCTION_IDS.OPEN_SMART_RECRUIT_WIDGET:
				parsedFunctions[CTA_ON_CLICK_FUNCTION_IDS.OPEN_SMART_RECRUIT_WIDGET]?.();
				break;
			case CTA_ON_CLICK_FUNCTION_IDS.OPEN_PRESC_UPD:
				parsedFunctions[CTA_ON_CLICK_FUNCTION_IDS.OPEN_PRESC_UPD]?.();
				break;
			case CTA_ON_CLICK_FUNCTION_IDS.OPEN_MEDCERT_PREV:
				parsedFunctions[CTA_ON_CLICK_FUNCTION_IDS.OPEN_MEDCERT_PREV]?.();
				break;
			case CTA_ON_CLICK_FUNCTION_IDS.OPEN_MEDCERT_EMP:
				parsedFunctions[CTA_ON_CLICK_FUNCTION_IDS.OPEN_MEDCERT_EMP]?.();
				break;
			case CTA_ON_CLICK_FUNCTION_IDS.OPEN_CHAT:
				window.Intercom?.('show');
				break;
			case CTA_ON_CLICK_FUNCTION_IDS.OPEN_CHAT_MESSAGE:
				window.Intercom?.('showNewMessage');
				break;
			case CTA_ON_CLICK_FUNCTION_IDS.DOWNLOAD:
				if (!downloadableAssetId) {
					console.warn(`No downloadableAssetId provided for onClickFunctionId: ${onClickFunctionId}`);
					return;
				}
				downloadResponse = await API_service.load_data("cms/download-proxy", {
					assetId: downloadableAssetId,
				});
				if (downloadResponse.res === "ok") {
					const link = document.createElement("a");
					link.href = downloadResponse.downloadUrl;
					link.download = downloadResponse.fileName;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				} else {
					console.error("Download failed:", downloadResponse?.error_message);
				}
				break;
			default:
				return console.warn(`No action defined for onClickFunctionId: ${onClickFunctionId}`);
		}
	}, [onClickFunctionId, parsedFunctions, downloadableAssetId]);
	return <ButtonContent {...buttonContentProps} onClick={onClick} />;
};

export default OnClickButton;
